import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import ScrollToTop from "./components/ScrollToTop";
import ReleaseBanner from "./components/ReleaseBanner/ReleaseBanner";
import UserRoute from "./Routes/UserRoute";
import { fetchDepartments } from "./features/departments/departmentThunks";
import { fetchEmployees } from "./features/employees/employeeThunks";
import { fetchAllProjects } from "./features/projects/projectThunks";
import { fetchAllGroups, fetchGroups } from "./features/groups/groupThunks";

const App = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  useEffect(() => {
    const isMaintenancePage = window.location.pathname === "/maintenance";
    if (isAuthenticated && !isMaintenancePage) {
      // Always re-fetch all data on login/mount — never rely on cached Redux
      // state for employee/department/project/group lists. This ensures backend
      // updates (new users, deleted records, etc.) are always reflected.
      dispatch(fetchDepartments());
      dispatch(fetchEmployees());
      dispatch(fetchAllProjects());
      dispatch(fetchGroups());    // populates paginated table state
      dispatch(fetchAllGroups()); // populates allGroups for AddTaskModal dropdown
    }
  }, [isAuthenticated, dispatch]);

  return (
    <>
      <ScrollToTop />
      <UserRoute />
      <ReleaseBanner />
    </>
  );
};

export default App;
